import React from 'react';

const Divider = () => <div className="divider" />;

export default Divider;
